import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { getCode } from '../../utils/utils'
import * as NavigationUtils from '../../utils/navigation';

import Home from './Home';
import Header from '../../components/Header';
import Container from '../../components/Container';
import { usePatientDocumentContext } from '../../contexts/PatientDocument';
import useTermsModal from '../../hooks/useTermsModal';

function HomeContainer() {
	const history = useHistory();
	const code = useMemo(() => getCode(), []);
	const { document, signedCode } = usePatientDocumentContext();

	const [acceptedTerms, setAcceptedTerms] = useState(false);
	const { isOpen, loading, content, title, closeModal, openTerms, openPrivacy } = useTermsModal();

	const navigateToSignaturePage = useCallback((status) => {
		const url = (status || document?.status) === 'SIGNED' ? `/signature-success?code=${code}` : `/document?code=${code}`

		NavigationUtils.navigate(history, url);
	}, [history, document?.status, code]);

	useEffect(() => {
		if (signedCode && signedCode === code) {
			history.replace(`/signature-success?code=${code}`);
		}
	}, [signedCode, code, history]);

    return (
		<Container>
			<Header/>

			<Home
				document={document}
				setAcceptedTerms={setAcceptedTerms}
				acceptedTerms={acceptedTerms}
				submit={navigateToSignaturePage}
				isOpen={isOpen}
				modalLoading={loading}
				content={content}
				title={title}
				closeModal={closeModal}
				openTerms={openTerms}
				openPrivacy={openPrivacy}
			/>
		</Container>
	);
}

export default HomeContainer;
